import React from "react";

type CurrencyInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

/** Number input with a rupee prefix for monetary amounts. */
export const CurrencyInput: React.FC<CurrencyInputProps> = ({ className = "", ...props }) => (
  <div className="eventos-currency-input">
    <span className="eventos-currency-input__symbol" aria-hidden="true">
      ₹
    </span>
    <input
      type="number"
      min={0}
      inputMode="decimal"
      className={`eventos-input eventos-currency-input__field ${className}`.trim()}
      {...props}
    />
  </div>
);
